var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "surface205080"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.988281 8.984375 C 24.726562 8.992188 24.476562 9.101562 24.292969 9.292969 L 15 18.585938 L 5.707031 9.292969 C 5.519531 9.097656 5.261719 8.992188 4.992188 8.988281 C 4.582031 8.992188 4.21875 9.238281 4.0625 9.613281 C 3.910156 9.992188 4 10.421875 4.292969 10.707031 L 14.292969 20.707031 C 14.683594 21.097656 15.316406 21.097656 15.707031 20.707031 L 25.707031 10.707031 C 26.003906 10.421875 26.09375 9.980469 25.9375 9.601562 C 25.777344 9.222656 25.402344 8.976562 24.988281 8.984375 Z M 24.988281 8.984375 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.fe10f9e2.svg";
export { ForwardRef as ReactComponent };